import { useProjects } from "../lib/ProjectContext";

export function ProjectSwitcher() {
  const { projects, selectedProjectId, selectProject, loading } = useProjects();

  if (loading) {
    return (
      <div className="title-block">
        <span className="title-block-label">Project</span>
        <span className="title-block-sub">Loading projects…</span>
      </div>
    );
  }
  if (projects.length === 0) {
    return (
      <div className="title-block">
        <span className="title-block-label">Project</span>
        <span className="title-block-sub">No projects yet</span>
      </div>
    );
  }

  const selected = projects.find((p) => p.id === selectedProjectId);

  return (
    <div className="title-block">
      <div className="title-block-field">
        <span className="title-block-label">Project</span>
        <select aria-label="Selected project" value={selectedProjectId ?? ""} onChange={(e) => selectProject(e.target.value)}>
          {projects.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
      </div>
      {selected?.contractNumber && <div className="title-block-sub">Contract #{selected.contractNumber}</div>}
    </div>
  );
}
